/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMilitaryRank = createReactComponent("military-rank", "IconMilitaryRank", [
  ["path", { d: "M17 7v13h-10v-13l5 -3z", key: "svg-0" }],
  ["path", { d: "M10 13l2 -1l2 1", key: "svg-1" }],
  ["path", { d: "M10 17l2 -1l2 1", key: "svg-2" }],
  ["path", { d: "M10 9l2 -1l2 1", key: "svg-3" }]
]);

export { IconMilitaryRank as default };
//# sourceMappingURL=IconMilitaryRank.js.map
